<template>
    <Layout :content-class="'content--narrow'" style="padding-bottom: 60px">
        <table class="phoneme-table" style="max-width: 940px; margin: 0 auto">
            <thead class="phoneme-table__head">
                <th class="phoneme-table__head-cell" style="width: 6%">id</th>
                <th class="phoneme-table__head-cell" style="width: 20%">Имя</th>
                <th class="phoneme-table__head-cell" style="width: 20%">Язык</th>
                <th class="phoneme-table__head-cell" style="width: 16%">
                    Провайдер
                    <VDropdown style="display: inline-block">
                        <button
                            type="button"
                            style="
                                border: none;
                                cursor: pointer;
                                background: none;
                                padding: 0;
                                outline: none;
                                margin-left: 2px;
                                transform: scale(0.8) translateY(2px);
                            "
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click.prevent
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.9501 7.11169C15.9248 6.88678 15.6626 6.71777 15.4358 6.71777C14.7027 6.71777 14.0522 6.2873 13.7793 5.62156C13.5006 4.93968 13.6803 4.14446 14.2267 3.64326C14.3987 3.48604 14.4196 3.22285 14.2753 3.04003C13.9001 2.56354 13.4736 2.13313 13.008 1.7601C12.8256 1.61377 12.5581 1.63413 12.4 1.80921C11.9231 2.33732 11.0666 2.53359 10.4047 2.25743C9.71594 1.96769 9.28159 1.26974 9.3241 0.520533C9.33809 0.285204 9.1661 0.0805941 8.93149 0.0532691C8.33391 -0.0158471 7.73109 -0.0179902 7.13173 0.0485066C6.8998 0.0741052 6.72781 0.273893 6.73561 0.506245C6.76168 1.24807 6.3221 1.93381 5.64017 2.21314C4.98621 2.48025 4.13568 2.28565 3.65979 1.76224C3.50251 1.58984 3.23932 1.56865 3.05608 1.71146C2.57661 2.08764 2.14054 2.51841 1.76186 2.99098C1.61417 3.17469 1.6359 3.44098 1.80961 3.59903C2.36641 4.10326 2.54619 4.90539 2.25693 5.59513C1.98076 6.25271 1.29793 6.67652 0.516226 6.67652C0.262562 6.66836 0.0818834 6.83862 0.0541417 7.06925C-0.0162246 7.67028 -0.0170581 8.28268 0.0506889 8.88859C0.0758112 9.11446 0.346025 9.28198 0.575281 9.28198C1.27192 9.26418 1.94076 9.69549 2.22133 10.3783C2.50101 11.0601 2.32122 11.8549 1.77401 12.3565C1.60286 12.5137 1.58113 12.7765 1.72537 12.9593C2.09709 13.4328 2.52363 13.8636 2.99095 14.2397C3.17425 14.3874 3.44095 14.3666 3.59984 14.1915C4.07848 13.6621 4.93496 13.4662 5.59421 13.7429C6.28471 14.0317 6.71906 14.7296 6.67655 15.4792C6.66268 15.7147 6.8355 15.9196 7.06916 15.9465C7.37486 15.9822 7.6824 16 7.99077 16C8.28349 16 8.57626 15.9839 8.86898 15.9514C9.10097 15.9258 9.27284 15.726 9.26504 15.4932C9.23819 14.7518 9.67855 14.0661 10.3596 13.7872C11.018 13.5183 11.8649 13.7151 12.3409 14.238C12.499 14.41 12.7604 14.4308 12.9446 14.2885C13.4232 13.9132 13.8584 13.4828 14.2388 13.0089C14.3865 12.8256 14.3656 12.5589 14.191 12.4009C13.6342 11.8967 13.4536 11.0944 13.7428 10.4052C14.0148 9.75633 14.6722 9.32067 15.3794 9.32067L15.4784 9.32323C15.7077 9.34187 15.9188 9.16518 15.9466 8.93104C16.0171 8.32947 16.0179 7.71761 15.9501 7.11169ZM8.01309 10.6854C6.54159 10.6854 5.34465 9.48843 5.34465 8.01693C5.34465 6.54549 6.54159 5.34849 8.01309 5.34849C9.48454 5.34849 10.6815 6.54549 10.6815 8.01693C10.6815 9.48843 9.48454 10.6854 8.01309 10.6854Z"
                                    fill="gray"
                                />
                            </svg>
                        </button>
                        <template #popper>
                            <CheckboxFilter
                                v-model="providerFilter"
                                compact
                                :options="providers"
                                :emit-prop="'id'"
                                :view-label="'name'"
                                style="
                                    background-color: #fff;
                                    border-radius: 5px;
                                    padding: 10px;
                                    font-size: 14px;
                                "
                            >
                                <template #default="{ option }">
                                    {{ option.name }}
                                </template>
                            </CheckboxFilter>
                        </template>
                    </VDropdown>
                </th>
                <th class="phoneme-table__head-cell" style="width: 10%">Сэмпл</th>
                <th class="phoneme-table__head-cell" style="width: 20%">
                    Рейтинг
                    <VDropdown style="display: inline-block">
                        <button
                            type="button"
                            style="
                                border: none;
                                cursor: pointer;
                                background: none;
                                padding: 0;
                                outline: none;
                                margin-left: 2px;
                                transform: scale(0.8) translateY(2px);
                            "
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click.prevent
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.9501 7.11169C15.9248 6.88678 15.6626 6.71777 15.4358 6.71777C14.7027 6.71777 14.0522 6.2873 13.7793 5.62156C13.5006 4.93968 13.6803 4.14446 14.2267 3.64326C14.3987 3.48604 14.4196 3.22285 14.2753 3.04003C13.9001 2.56354 13.4736 2.13313 13.008 1.7601C12.8256 1.61377 12.5581 1.63413 12.4 1.80921C11.9231 2.33732 11.0666 2.53359 10.4047 2.25743C9.71594 1.96769 9.28159 1.26974 9.3241 0.520533C9.33809 0.285204 9.1661 0.0805941 8.93149 0.0532691C8.33391 -0.0158471 7.73109 -0.0179902 7.13173 0.0485066C6.8998 0.0741052 6.72781 0.273893 6.73561 0.506245C6.76168 1.24807 6.3221 1.93381 5.64017 2.21314C4.98621 2.48025 4.13568 2.28565 3.65979 1.76224C3.50251 1.58984 3.23932 1.56865 3.05608 1.71146C2.57661 2.08764 2.14054 2.51841 1.76186 2.99098C1.61417 3.17469 1.6359 3.44098 1.80961 3.59903C2.36641 4.10326 2.54619 4.90539 2.25693 5.59513C1.98076 6.25271 1.29793 6.67652 0.516226 6.67652C0.262562 6.66836 0.0818834 6.83862 0.0541417 7.06925C-0.0162246 7.67028 -0.0170581 8.28268 0.0506889 8.88859C0.0758112 9.11446 0.346025 9.28198 0.575281 9.28198C1.27192 9.26418 1.94076 9.69549 2.22133 10.3783C2.50101 11.0601 2.32122 11.8549 1.77401 12.3565C1.60286 12.5137 1.58113 12.7765 1.72537 12.9593C2.09709 13.4328 2.52363 13.8636 2.99095 14.2397C3.17425 14.3874 3.44095 14.3666 3.59984 14.1915C4.07848 13.6621 4.93496 13.4662 5.59421 13.7429C6.28471 14.0317 6.71906 14.7296 6.67655 15.4792C6.66268 15.7147 6.8355 15.9196 7.06916 15.9465C7.37486 15.9822 7.6824 16 7.99077 16C8.28349 16 8.57626 15.9839 8.86898 15.9514C9.10097 15.9258 9.27284 15.726 9.26504 15.4932C9.23819 14.7518 9.67855 14.0661 10.3596 13.7872C11.018 13.5183 11.8649 13.7151 12.3409 14.238C12.499 14.41 12.7604 14.4308 12.9446 14.2885C13.4232 13.9132 13.8584 13.4828 14.2388 13.0089C14.3865 12.8256 14.3656 12.5589 14.191 12.4009C13.6342 11.8967 13.4536 11.0944 13.7428 10.4052C14.0148 9.75633 14.6722 9.32067 15.3794 9.32067L15.4784 9.32323C15.7077 9.34187 15.9188 9.16518 15.9466 8.93104C16.0171 8.32947 16.0179 7.71761 15.9501 7.11169ZM8.01309 10.6854C6.54159 10.6854 5.34465 9.48843 5.34465 8.01693C5.34465 6.54549 6.54159 5.34849 8.01309 5.34849C9.48454 5.34849 10.6815 6.54549 10.6815 8.01693C10.6815 9.48843 9.48454 10.6854 8.01309 10.6854Z"
                                    fill="gray"
                                />
                            </svg>
                        </button>
                        <template #popper>
                            <CheckboxFilter
                                v-model="ratingFilter"
                                compact
                                :options="ratings"
                                :emit-prop="'id'"
                                :view-label="'name'"
                                style="
                                    background-color: #fff;
                                    border-radius: 5px;
                                    padding: 10px;
                                    font-size: 14px;
                                "
                                :is-disabled="
                                    (option) =>
                                        ratingFilter.length > 1 && !ratingFilter.includes(option.id)
                                "
                            >
                                <template #default="{ option }">
                                    <span style="color: gold">
                                        {{ option.name }}
                                    </span>
                                </template>
                            </CheckboxFilter>
                        </template>
                    </VDropdown>
                </th>
                <th class="phoneme-table__head-cell" style="width: 7%">
                    Рек.
                    <VDropdown style="display: inline-block">
                        <button
                            type="button"
                            style="
                                border: none;
                                cursor: pointer;
                                background: none;
                                padding: 0;
                                outline: none;
                                margin-left: 2px;
                                transform: scale(0.8) translateY(2px);
                            "
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click.prevent
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.9501 7.11169C15.9248 6.88678 15.6626 6.71777 15.4358 6.71777C14.7027 6.71777 14.0522 6.2873 13.7793 5.62156C13.5006 4.93968 13.6803 4.14446 14.2267 3.64326C14.3987 3.48604 14.4196 3.22285 14.2753 3.04003C13.9001 2.56354 13.4736 2.13313 13.008 1.7601C12.8256 1.61377 12.5581 1.63413 12.4 1.80921C11.9231 2.33732 11.0666 2.53359 10.4047 2.25743C9.71594 1.96769 9.28159 1.26974 9.3241 0.520533C9.33809 0.285204 9.1661 0.0805941 8.93149 0.0532691C8.33391 -0.0158471 7.73109 -0.0179902 7.13173 0.0485066C6.8998 0.0741052 6.72781 0.273893 6.73561 0.506245C6.76168 1.24807 6.3221 1.93381 5.64017 2.21314C4.98621 2.48025 4.13568 2.28565 3.65979 1.76224C3.50251 1.58984 3.23932 1.56865 3.05608 1.71146C2.57661 2.08764 2.14054 2.51841 1.76186 2.99098C1.61417 3.17469 1.6359 3.44098 1.80961 3.59903C2.36641 4.10326 2.54619 4.90539 2.25693 5.59513C1.98076 6.25271 1.29793 6.67652 0.516226 6.67652C0.262562 6.66836 0.0818834 6.83862 0.0541417 7.06925C-0.0162246 7.67028 -0.0170581 8.28268 0.0506889 8.88859C0.0758112 9.11446 0.346025 9.28198 0.575281 9.28198C1.27192 9.26418 1.94076 9.69549 2.22133 10.3783C2.50101 11.0601 2.32122 11.8549 1.77401 12.3565C1.60286 12.5137 1.58113 12.7765 1.72537 12.9593C2.09709 13.4328 2.52363 13.8636 2.99095 14.2397C3.17425 14.3874 3.44095 14.3666 3.59984 14.1915C4.07848 13.6621 4.93496 13.4662 5.59421 13.7429C6.28471 14.0317 6.71906 14.7296 6.67655 15.4792C6.66268 15.7147 6.8355 15.9196 7.06916 15.9465C7.37486 15.9822 7.6824 16 7.99077 16C8.28349 16 8.57626 15.9839 8.86898 15.9514C9.10097 15.9258 9.27284 15.726 9.26504 15.4932C9.23819 14.7518 9.67855 14.0661 10.3596 13.7872C11.018 13.5183 11.8649 13.7151 12.3409 14.238C12.499 14.41 12.7604 14.4308 12.9446 14.2885C13.4232 13.9132 13.8584 13.4828 14.2388 13.0089C14.3865 12.8256 14.3656 12.5589 14.191 12.4009C13.6342 11.8967 13.4536 11.0944 13.7428 10.4052C14.0148 9.75633 14.6722 9.32067 15.3794 9.32067L15.4784 9.32323C15.7077 9.34187 15.9188 9.16518 15.9466 8.93104C16.0171 8.32947 16.0179 7.71761 15.9501 7.11169ZM8.01309 10.6854C6.54159 10.6854 5.34465 9.48843 5.34465 8.01693C5.34465 6.54549 6.54159 5.34849 8.01309 5.34849C9.48454 5.34849 10.6815 6.54549 10.6815 8.01693C10.6815 9.48843 9.48454 10.6854 8.01309 10.6854Z"
                                    fill="gray"
                                />
                            </svg>
                        </button>
                        <template #popper>
                            <CheckboxFilter
                                v-model="isRecommendedFilter"
                                compact
                                :options="recommendedOptions"
                                :emit-prop="'id'"
                                style="
                                    background-color: #fff;
                                    border-radius: 5px;
                                    padding: 10px;
                                    font-size: 14px;
                                "
                            >
                                <template #default="{ option }">
                                    <span>
                                        {{ option.name }}
                                    </span>
                                </template>
                            </CheckboxFilter>
                        </template>
                    </VDropdown>
                </th>
            </thead>
            <tbody v-if="speakers.length">
                <tr v-for="sp in speakers" :key="sp.id" class="phoneme-table__row">
                    <td class="phoneme-table__cell">{{ sp.id }}</td>
                    <td class="phoneme-table__cell">{{ sp.name[$i18n.locale] }}</td>
                    <td class="phoneme-table__cell">{{ sp.language.label[$i18n.locale] }}</td>
                    <td class="phoneme-table__cell">{{ sp.provider.name }}</td>
                    <td class="phoneme-table__cell">
                        <div v-if="sp.sample" class="phoneme-table__withplayer">
                            <SmallPlayer
                                :src="sp.sample"
                                :active="active === sp.sample"
                                @playing="setPlaying"
                                @paused="setPlaying"
                            />
                        </div>
                    </td>
                    <td class="phoneme-table__cell">
                        <span v-for="n in Math.round(sp.rating)" :key="n" style="color: gold">
                            ★
                        </span>
                    </td>
                    <td class="phoneme-table__cell">
                        <svg
                            v-if="sp.is_recommended"
                            width="12"
                            height="12"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 19.481 19.481"
                        >
                            <path
                                fill="#A6A7BE"
                                d="M10.201.758l2.478 5.865 6.344.545a.5.5 0 01.285.876l-4.812 4.169 1.442 6.202a.5.5 0 01-.745.541l-5.452-3.288-5.452 3.288a.5.5 0 01-.745-.541l1.442-6.202-4.813-4.17a.5.5 0 01.285-.876l6.344-.545L9.28.758a.5.5 0 01.921 0z"
                            />
                        </svg>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="!speakers.length">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="8">
                        {{ $t('misc.notfound') }}
                    </td>
                </tr>
            </tbody>
            <tbody v-if="loading">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="8">
                        <Spinner v-if="loading" class="spinner--gray" />
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="canLoadMore"
            class="button button--centered button--medium"
            type="button"
            style="margin-top: 30px"
            :disabled="loading"
            @click="loadMore"
        >
            Загрузить ещё
        </button>
    </Layout>
</template>

<script>
import { ApiClient } from '@/plugins/axios';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import CheckboxFilter from '@speechki-frontend/shared/ui/CheckboxFilter';
import { Dropdown } from 'floating-vue';
import { SmallPlayer } from '@speechki-frontend/shared/ui/Player';

export default {
    name: 'SpeakersPage',
    components: {
        Layout,
        VDropdown: Dropdown,
        CheckboxFilter,
        SmallPlayer,
    },
    data() {
        return {
            speakers: [],
            providers: [],
            loading: false,
            count: 0,
            pageSize: 20,
            page: 1,
            providerFilter: [],
            ratingFilter: [],
            ratings: [
                { id: 5, name: '★★★★★' },
                { id: 4, name: '★★★★' },
                { id: 3, name: '★★★' },
                { id: 2, name: '★★' },
                { id: 1, name: '★' },
            ],
            isRecommendedFilter: [],
            recommendedOptions: [
                { id: 'true', name: 'Recommended' },
                { id: 'false', name: 'Not recommended' },
            ],
            active: undefined,
        };
    },
    computed: {
        canLoadMore() {
            return this.count > this.page * this.pageSize;
        },
    },
    watch: {
        page() {
            this.fetchSpeakers();
        },
        providerFilter() {
            this.page = 1;
            this.fetchSpeakers();
        },
        ratingFilter() {
            this.page = 1;
            this.fetchSpeakers();
        },
        isRecommendedFilter() {
            this.page = 1;
            this.fetchSpeakers();
        },
    },
    async created() {
        await Promise.all([this.fetchProviders(), this.fetchSpeakers()]);
    },
    methods: {
        async fetchProviders() {
            try {
                const { results } = await ApiClient.get(
                    '/api/v1/admin/speech_settings/providers/?page_size=50'
                );

                this.providers = results;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchSpeakers() {
            try {
                this.loading = true;
                const params = {
                    page: this.page,
                    page_size: this.pageSize,
                    ordering: '-rating',
                };

                if (this.providerFilter.length) {
                    if (this.providerFilter.length > 1) {
                        params.provider__in = this.providerFilter.join(',');
                    } else {
                        params.provider = this.providerFilter[0];
                    }
                }

                if (this.ratingFilter.length) {
                    if (this.ratingFilter.length > 1) {
                        params.rating__range = this.ratingFilter.join(',');
                    } else {
                        params.rating = this.ratingFilter[0];
                    }
                }

                if (this.isRecommendedFilter.length && this.isRecommendedFilter.length < 2) {
                    params.is_recommended = this.isRecommendedFilter[0];
                }

                const { results, count } = await ApiClient.get(
                    '/api/v1/admin/speech_settings/speakers/',
                    { params }
                );

                if (this.page === 1) {
                    this.speakers = results;
                    this.count = count;
                } else {
                    this.speakers = [...this.speakers, ...results];
                }

                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        },
        loadMore() {
            this.page = this.page + 1;
        },
        setPlaying(src) {
            this.active = src;
        },
    },
};
</script>
